<nb-layout>
  <nb-layout-column>
    <div *ngIf="responsiveMode === 'lg'"
         class="d-flex flex-column align-items-center justify-content-center position-relative error-500">
      <div class="m-auto py-5 text-center">
        <img src="assets/images/errors/error-ip.png" alt="" style="width: 80%;">
        <div class="d-flex flex-column align-items-center justify-content-between text-position ">
          <p class="main-text">محدودیت دسترسی</p>
          <p class="info mb-3 mt-1 type-1">
            دسترسی شما به نرم افزار تارت به دلیل محدودیت نشانی IP امکان‌پذیر نمی‌باشد.
          </p>
          <p class="info d-flex" *ngIf="userIp">
            <span> نشانی IP: </span>
            <span class="mx-1"> {{userIp|persianNumber}} </span>
          </p>
          <p class="description" style="font-size: 16px;">برای رفع مشکل با تیم پشتیبانی تارت ارتباط بگیرید.</p>
          <div class="button-action action-link" *ngIf="supporterContactInfo.contactInfoType === 'Email'">
            <a href="mailto:{{supporterContactInfo.email}}">
              راه ارتباطی با پشتیبانی:
              <br/>
              {{supporterContactInfo.email}}
            </a>
          </div>
          <div class="button-action action-link" *ngIf="supporterContactInfo.contactInfoType === 'PhoneNumber'">
              راه ارتباطی با پشتیبانی:
              <br/>
              {{supporterContactInfo.phoneNumber}}
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="responsiveMode === 'md'" class="m-auto">
      <img src="assets/images/errors/error-ip.png" alt="">
      <div class="d-flex flex-column align-items-center justify-content-between">
        <p class="main-text">محدودیت دسترسی</p>
        <p class="info mb-3 mt-1 type-1">
          دسترسی شما به نرم افزار تارت به دلیل محدودیت نشانی IP امکان‌پذیر نمی‌باشد.
        </p>
        <p class="info d-flex" *ngIf="userIp">
          <span> نشانی IP: </span>
          <span class="mx-1"> {{userIp|persianNumber}} </span>
        </p>
        <p class="description" style="font-size: 16px;">برای رفع مشکل با تیم پشتیبانی تارت ارتباط بگیرید.</p>
          <div class="button-action action-link" *ngIf="supporterContactInfo.contactInfoType === 'Email'">
            <a href="mailto:{{supporterContactInfo.email}}">
              راه ارتباطی با پشتیبانی:
              <br/>
              {{supporterContactInfo.email}}
            </a>
          </div>
          <div class="button-action action-link" *ngIf="supporterContactInfo.contactInfoType === 'PhoneNumber'">
              راه ارتباطی با پشتیبانی:
              <br/>
              {{supporterContactInfo.phoneNumber}}
          </div>
        </div>
      </div>
  </nb-layout-column>
</nb-layout>

